<template>
  <div class="s-chat__content__body__greeting u-padding">
    <h1><i class="icofont-robot"></i></h1>
    <p>{{ $t(content) }}</p>
    <div class="u-margin-top">
      <img src="@/assets/images/Logo.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "ReservationNotFound",
  props: {
    content: {
      type: String,
      required: true,
      default: "chat.content.reservationNotFound",
    },
  },
};
</script>

<style></style>
